import {CodeIdentityModel} from './code-identity.model';

export class CityModel {
  id: 0;
  code: string;
  description: string;
  district: CodeIdentityModel;
}



// WEBPACK FOOTER //
// ./src/app/servizi/tesseramento/model/city.model.ts